export default __webpack_public_path__ + "static/media/offer_type_2.08e5acd8.png";